// extracted by mini-css-extract-plugin
module.exports = {"radio":"RadioInput_radio__D0zoC","checked":"RadioInput_checked__3EZrb"};